<template>
    <b-tab title="ข้อมูลงาน">
        <b-card-body>
            <b-row class="mb-3">
                <b-col cols="12">
                    <h3>ข้อมูลลูกค้า/บริษัท</h3>
                </b-col>
            </b-row>
            <JobCustomer 
                :form="form" 
            />
            <!-- <b-row class="mb-4">
                <b-col cols="12" class="mb-4">
                    <h3 slot="header" class="mb-0">
                        พนักงานขับรถ
                    </h3>
                </b-col>
                <b-col lg="6" cols="9">
                    <multiselect
                        v-model="selected"
                        deselect-label="Can't remove this value"
                        track-by="id"
                        label="username"
                        placeholder="ค้นหารายชื่อ"
                        :options="empoyeeList"
                        :allow-empty="false"
                        :disabled="!!form.driver"
                    >
                    </multiselect>
                </b-col>
                <b-col cols="3">
                    <b-button
                        variant="success"
                        block
                        @click="$emit('createDriverJob')"
                        :disabled="!!form.driver"
                    >บันทึก
                    </b-button>
                </b-col>
            </b-row> -->
            <hr class="my-3" />
            <b-form>
                <JobDriver :form="form" />
                <!-- <b-row class="my-4">
                    <b-col cols="12">
                        <h3>ข้อมูลราคางาน</h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" cols="12">
                        <b-form-group 
                            label="ชื่อราคางาน"
                        >
                            <b-form-input 
                                v-model="form.job_name" 
                                placeholder="ระบุชื่อราคางาน"
                                disabled
                            />
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <hr class="my-3" />
                <!-- <b-row class="mb-4">
                    <b-col cols="12">
                        <h3>ข้อมูลลูกค้า</h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" cols="12">
                        <b-form-group label="รายชื่อลูกค้า">
                            <multiselect
                                v-model="form.customer"
                                deselect-label="Can't remove this value"
                                track-by="id"
                                label="f_name"
                                placeholder="ค้นหารายชื่อ"
                                :options="customerList"
                                :allow-empty="false"
                            >
                            </multiselect>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="6" cols="12">
                        <b-form-group label="ประเภทราคา">
                            <b-form-select
                                v-model="form.rate_type"
                                disabled
                            >
                                <b-form-select-option value="system" disabled>
                                    ตามระบบ
                                </b-form-select-option>
                                <b-form-select-option value="custom"
                                    >กำหนดเอง
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="form.rate_type === 'custom'">
                    <b-col lg="6" cols="12">
                        <b-form-group label="ประเภทรถ">
                            <small>{{ form.vehicle_type }}</small>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <!-- <hr class="my-3" /> -->
                <b-row class="mt-4">
                    <b-col cols="12">
                        <h3>รายละเอียดงาน</h3>
                    </b-col>
                    <b-col lg="12" cols="12" class="card-border-radius p-4">
                        <JobOrderDetail :form="form" />
                    </b-col>
                </b-row>
                <hr class="my-3" />
                <CategoryRoute :form="form" />
                <b-row class="mt-4">
                    <b-col lg="12" cols="12" class="card-border-radius px-0">
                        <JobRoute :form="form" :category="false" :isEdit="!!this.$route.params.id"/>
                    </b-col>
                </b-row>
                <b-row class="mt-4">
                    <b-col lg="12" cols="12" class="card-border-radius px-0">
                        <AdditionalWork :form="form" />
                    </b-col>
                </b-row>
                <b-row class="mt-4 justify-content-end">
                    <b-col lg="6" cols="12" class="card-border-radius p-4">
                        <b-row class="my-1">
                            <b-col cols="8">
                                <label for="input-total">รวมเป็นเงิน</label>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 for="input-total">{{
                                    form.rate_before_vat | number
                                }}</h3>
                            </b-col>
                        </b-row>
                        <hr class="my-3" />
                        <b-row class="my-1">
                            <b-col cols="8">
                                <b-form inline>
                                    <label for="input-fee" class="mr-1">ค่าบริการ</label>
                                    <label id="input-fee">
                                    {{ form.fee ? `${form.fee} %` : "" }}</label
                                    >
                                </b-form>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 for="input-service-fee">{{
                                    form.price_service_fee | number
                                }}</h3>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col cols="8">
                                <label for="input-after_service_fee">ราคาหลังเพิ่มค่าบริการ</label>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 for="input-after_service_fee">{{
                                    form.price_after_service_fee | number
                                }}</h3>
                            </b-col>
                        </b-row>
                        <hr class="my-3" />
                        <b-row class="my-1">
                            <b-col cols="8">
                                <b-form inline>
                                    <label for="input-discount" class="mr-1">ส่วนลด</label>
                                    <label id="input-discount">
                                    {{
                                        form.discount ? `${form.discount} %` : ""
                                    }}</label
                                    >
                                </b-form>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 for="input-price_discount">{{
                                    form.price_discount | number
                                }}</h3>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col cols="8">
                                <label for="input-price_after_discount">ราคาหลังหักส่วนลด</label>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 id="input-price_after_discount">{{
                                    form.price_after_discount | number
                                }}</h3>
                            </b-col>
                        </b-row>
                        <hr class="my-3" />
                        <b-row class="my-1">
                            <b-col cols="8">
                                <b-form inline>
                                    <label for="input-vat-percent">ภาษีมูลค่าเพิ่ม</label>
                                    <label id="input-vat-percent">
                                    {{
                                        form.vatPercent ? `${form.vatPercent} %` : ""
                                    }}</label
                                    >
                                </b-form>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 for="input-vat">{{ form.vat | number }}</h3>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col cols="8">
                                <label for="input-price_vat">ราคารวมภาษีมูลค่าเพิ่ม</label>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 id="input-price_vat">{{
                                    form.price_vat | number
                                }}</h3>
                            </b-col>
                        </b-row>
                        <hr class="my-3" />
                        <b-row class="my-1">
                            <b-col cols="8">
                                <b-form inline>
                                    <label for="input-withholdingTaxPercent">หักภาษี ณ ที่จ่าย</label>
                                    <label id="input-withholdingTaxPercent">
                                    {{
                                            form.withholdingTaxPercent
                                        ? `${form.withholdingTaxPercent} %`
                                        : ""
                                    }}</label
                                    >
                                </b-form>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 for="input-withholdingTax">{{
                                    form.withholdingTax | number
                                }}</h3>
                            </b-col>
                        </b-row>
                        <hr class="my-3" />
                        <b-row class="my-1">
                            <b-col cols="8">
                                <span for="input-net" class="h3 font-weight-bold">ยอดสุทธิ</span>
                            </b-col>
                            <b-col cols="4" class="text-right">
                                <h3 id="input-net">
                                    {{ form.net | number }}
                                </h3>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <hr class="my-4" />
                <div class="d-flex justify-content-between">
                    <base-button
                        type="secondary"
                        class=""
                        @click="
                            $router.push({
                            name: 'manageJob',
                            })
                        "
                    >
                        ย้อนกลับ
                    </base-button>
                </div>
            </b-form>
        </b-card-body>
    </b-tab>
</template>

<script>
import JobCustomer from "@/views/Pages/Admin/Job/components/JobCustomer.vue";
import JobDriver from "@/views/Pages/Admin/Job/components/JobDriver.vue";
import CategoryRoute from "@/views/Pages/Admin/Job/components/CategoryRoute.vue";
import JobOrderDetail from "@/views/Pages/Admin/Job/components/JobOrderDetail.vue";
import AdditionalWork from "@/views/Pages/Admin/Job/components/AdditionalWork.vue";
import JobRoute from "@/views/Pages/Admin/Job/components/JobRoute.vue";
export default {
    props:{
        form: {
            type: Object
        },
        customerList: {
            type: Array
        },
        selected: {
            type: Object
        }
    },
    components: {
        JobCustomer,
        JobDriver,
        CategoryRoute,
        JobOrderDetail,
        AdditionalWork,
        JobRoute
    },
    watch: {
        selected: function (value) { 
            this.$emit('selected', value)
        }
    }
}
</script>
